export interface ModuleIdApi {
  moduleId: string;
}

export let isModuleIdResponseDTO = (
  variable: unknown
): variable is ModuleIdApi => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "object" &&
    "moduleId" in variable &&
    typeof variable.moduleId === "string"
  );
};

export interface ModuleIdsApi extends ModuleIdApi {
  moduleResourceIds: string[];
}

export let isModuleIdsResponseDTO = (
  variable: unknown
): variable is ModuleIdsApi => {
  return (
    isModuleIdResponseDTO(variable) &&
    "moduleResourceIds" in variable &&
    Array.isArray(variable.moduleResourceIds) &&
    variable.moduleResourceIds.reduce(
      (doArrayConsistOfModuleResourceIds, moduleResourceId: unknown) =>
        doArrayConsistOfModuleResourceIds &&
        typeof moduleResourceId === "string",
      true
    )
  );
};
